export default "__VITE_ASSET__xAAaWpYV__"